
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from "@angular/core";
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@angular/core';

@Component({
    selector: 'push-notif-image-modal',
    templateUrl: "./push-notif-image-modal.html",
    styleUrls: ["./push-notif-image-modal.scss"]
})
export class ImageModalPush {

    @Input() imgId: string;
    faExclamationCircle = faExclamationCircle;
    faTimes = faTimes;
    constructor(public activeModal: NgbActiveModal) { }
}


// WEBPACK FOOTER //
// ./src/app/push-notification/push-notif-image-modal/push-notif-image-modal.ts